export default __webpack_public_path__ + "static/media/search_icon.48a91d0e.svg";